import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/useBoundStore';

export const saveAccountOpeningReason = async (reason: string) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/accountOpeningReason`
    : `v3/secureonboarding/user/${customerId}/accountOpeningReason`;
  return HttpService.post(url, { reason });
};
